import LoggedOut from "../../../../layouts/loggedOut.layout";
import SingleCardLayout from "../../../../layouts/singleCard.layout";
import Page from "./page.unauthenticated.passwordReset.user.page";

const UnauthenticatedPasswordResetLayout = () => {
  return (
    <LoggedOut>
      <SingleCardLayout>
        <Page />
      </SingleCardLayout>
    </LoggedOut>
  );
};

export default UnauthenticatedPasswordResetLayout;
